import { assoc, compose, pick } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSaveIntegrations } from '../../_requests/saveIntegrations'
import Form from '../../../../../packages/kiti/components/form/form/Form'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../../../packages/kiti/components/form/SubmitBar'

const cleanRequest = (form, currentProjectId) => {
  return compose(
    pick(['id', 'service', 'name', 'token']),
    item => assoc('name', 'Segware', item),
    item => assoc('service', 'SEGWARE', item),
    item => assoc('token', `${item.tokenApi}:${item.companyId}:${currentProjectId}`, item)
  )(form)
}

const FormSegware = ({ integrationId, moveBackOnSuccess }) => {
  const { t } = useTranslation('listIntegrations')
  const shouldUseProjectId = true
  const [save, { loading, error }] = useSaveIntegrations(cleanRequest, moveBackOnSuccess, shouldUseProjectId)

  return (
    <Form initialState={{ id: integrationId, service: 'segware' }} onSubmit={save}>
      <FormItem label={t('segware.companyId')} field="companyId" />
      <Separator weight={2} />
      <FormItem label={t('segware.bearerToken')} field="tokenApi" />
      <SubmitBar loading={loading} error={error} />
    </Form>
  )
}

export default FormSegware
